import React from 'react';
import MediaQueries from 'react-responsive';

import MaxWidth from '@marvelapp/marvel-ui/max-width';
import Spacing from '@marvelapp/marvel-ui/spacing';
import Heading from '@marvelapp/marvel-ui/heading';
import Paragraph from '@marvelapp/marvel-ui/paragraph';
import Align from '@marvelapp/marvel-ui/align';

import Grid, { GridItem } from '@marvelapp/marvel-ui/grid';
import Image from 'marketing-website/components/modules/Image';
import assets from 'marketing-website/configs/pages/ios-app-builder/assets';

export default function Share() {
  return (
    <Spacing size="xs" sizeM="l" type="padding" position="topBottom">
      <MaxWidth value={720}>
        <Grid columns={2} size="l" alignItems="center" justifyContent="center">
          <MediaQueries maxWidth={1200} />
          <GridItem columnSpan={2} columnSpanM={1}>
            <Align type="center" typeM="left">
              <Spacing size="s" type="padding" position="topBottom">
                <Heading tag="h2" weight="semibold" size="xl">
                  Share the download link
                </Heading>
              </Spacing>
              <Paragraph size="l" color="slate">
                Marvel will automatically generate a download page for your iOS
                app build. Simply send the link to your device and install.
              </Paragraph>
            </Align>
          </GridItem>
          <GridItem>
            <Spacing size="l" type="padding" position="topBottom">
              <Image {...assets.devicesRetina} />
            </Spacing>
          </GridItem>
        </Grid>
      </MaxWidth>
    </Spacing>
  );
}



// WEBPACK FOOTER //
// ./src/pages/ios-app-builder/share.js